import {css} from "@emotion/react";

import {NAVIGATION_TAB_BAR_HEIGHT} from "@atg-navigation-shared/main-navbar-utils";

export const globalStyles = css`
    :root {
        /* Tab bar variables */
        --navigation-tab-bar-height: ${NAVIGATION_TAB_BAR_HEIGHT}px;
    }
`;
